﻿import { ensureSwiper } from "@js/core/loaders/vendors";

export async function initProductsSwiper() {
    const root = document.querySelector(".swiper--products");
    if (!root) return;

    const Swiper = await ensureSwiper();
    if (!Swiper) return;

    new Swiper(".swiper--products", {
        slidesPerView: 1.25,
        spaceBetween: 32,
        pagination: {
            el: ".swiper--products-pagination .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper--products-navigation .swiper-button-next",
            prevEl: ".swiper--products-navigation .swiper-button-prev"
        },
        grabCursor: true,
        effect: "creative",
        creativeEffect: {
            prev: {
                shadow: true,
                translate: ["-110%", 0, -200]
            },
            next: {
                shadow: true,
                translate: ["110%", 0, -200]
            }
        },
        breakpoints: {
            320: {
                slidesPerView: 1.1,
                spaceBetween: 16
            },
            480: {
                slidesPerView: 1.2,
                spaceBetween: 24
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 32
            }
        }
    });
}

export async function initEventsSwiper() {
    const root = document.querySelector(".swiper--events");
    if (!root) return;

    const Swiper = await ensureSwiper();
    if (!Swiper) return;

    new Swiper(".swiper--events", {
        slidesPerView: 3.5,
        spaceBetween: 32,
        pagination: {
            el: ".swiper--events-pagination .swiper-pagination"
        },
        navigation: {
            nextEl: ".swiper--events-navigation .swiper-button-next",
            prevEl: ".swiper--events-navigation .swiper-button-prev"
        },
        breakpoints: {
            320: {
                slidesPerView: 1.25,
                spaceBetween: 16
            },
            480: {
                slidesPerView: 2.5,
                spaceBetween: 24
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 32
            }
        }
    });
}